import { useEffect, useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import SyncIcon from "../../../components/SyncIcon/SyncIcon";
import { useSSEContext } from "../../../contexts/sse";
import { useUserStore } from "../../../contexts/userStore";
import AcessGroupService from "../../../services/AccessGroupService";
import "./ListAccessGroups.css";
import { useAuth } from "../../../contexts/auth";
import { MultiLicensesStatus } from "../../../components/MultiLicensesStatus/MultiLicensesStatus";

const DEFAULT_SORT = {
	collumnTitle: "createdAt",
	orderDirection: "DESC",
};

function parseLicenseStatus(data, old) {
	if (!data?.content?.result?.status) {
		return old;
	}
	if (data.content.result.status === 'success') {
		return 'synced';
	}
	return 'notSynced';
}

const ListAccessGroups = (props) => {
	const [accessGroup, setAccessGroup] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(6);
	const [total, setTotal] = useState(0);
	const { user } = useAuth();
	const [currentPage, setCurrentPage] = useState(1);
	const { sseReceived, subscribeToActions, unsubscribeToActions } = useSSEContext();
	const [collumnClicked, setCollumnClicked] = useState(DEFAULT_SORT);
	const [isLoading, setIsLoading] = useState(true);
	const cancelTokenRef = useRef(null);

	const getAccessGroups = async (
		page,
		searchText,
		organizationId,
		collumnClicked
	) => {
		if (organizationId === 0) return;
		if (cancelTokenRef.current) {
			cancelTokenRef.current.abort();
		}
		cancelTokenRef.current = new AbortController();
		setIsLoading(true);
		const response = await AcessGroupService.listAccessGroupsPaginated(
			page,
			searchText.search || "",
			organizationId,
			collumnClicked,
			cancelTokenRef.current.signal,
			rowsPerPage,
			searchText.unitId || null,
			searchText,
		);
		setIsLoading(false);
		if (response?.data?.items) {
			setAccessGroup(response.data?.items);
			setCurrentPage(page);
			setMaxPage(response.data?.totalPages);
			setTotal(response?.data?.total);
		} else {
			setAccessGroup([]);
			setCurrentPage(1);
			setMaxPage(1);
			setTotal(0);
		}
	};

	useEffect(() => {
		setCurrentPage(1);
	}, [props.filters]);

	useEffect(() => {
		getAccessGroups(
			currentPage,
			props.filters,
			user.userData.selectedOrganizationId,
			collumnClicked
		);
	}, [
		props.filters,
		user.userData.selectedOrganizationId,
		collumnClicked,
		props.refreshKey,
		currentPage,
		rowsPerPage
	]);

	useEffect(() => {
		if (["replyGroupReceived"].includes(sseReceived?.action)) {
			if (accessGroup.find(g => g.licenses?.some(l => l.mqtt_id === sseReceived.content?.mqtt_id))) {
				setAccessGroup(prev => prev.map(item => {
					return {
						...item,
						licenses: item.licenses.map(l => l.mqtt_id === sseReceived.content?.mqtt_id ? {
							...l,
							status: parseLicenseStatus(sseReceived, l.status),
						} : l)
					}
				}));
			} else {
				getAccessGroups(
					currentPage,
					props.filters,
					user.userData.selectedOrganizationId,
					collumnClicked
				);
			}
		}
	}, [
		sseReceived,
	]);

	useEffect(() => {
		subscribeToActions(["replyGroupReceived"], -1);
		return () => {
			unsubscribeToActions(["replyGroupReceived"], -1);
		}
	}, []);

	return (
		<>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setCollumnClicked(collumnIndex)
					}
					listEntityName="groups"
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{
							collumnLabel: "Data de Início",
							index: "start_date",
							type: "date",
						},
						{ collumnLabel: "Data de Fim", index: "end_date", type: "date" },
						{
							columnClassName: `w-[90px]!`,
							collumnLabel: "Status Equipamentos",
							index: "status",
							multipleStatus: true,
							custom: ({ row }) => <MultiLicensesStatus id={row.id} listEntityName={'groups'} licenses={row.licenses} />
						},
					]}
					data={accessGroup}
				/>
			</div>
			<div className="card-visibility">
				{accessGroup &&
					accessGroup.map((accessGroup, index) => (
						<Card
							key={index}
							data={accessGroup}
							delete={() => AcessGroupService.deleteAccessGroup(accessGroup.id)}
							navigateOnDelete={"../consulta-access-groups"}
							navigateOnEdit={"../cadastro-access-groups"}
							aditionalButton1={
								<SyncIcon
									isCard={true}
									syncStatus={accessGroup.status}
									data={accessGroup}
									listEntityName={"groups"}
								/>
							}
						>
							<p className="card-content-title">{accessGroup.name}</p>
							<p className="card-content">
								Descrição: {accessGroup.description}
							</p>
							<p className="card-content">
								Data Início: {accessGroup.start_date}
							</p>
							<p className="card-content">Data Fim: {accessGroup.end_date}</p>
							<p className="card-content">
								Hora Início: {accessGroup.start_hour}
							</p>
							<p className="card-content">Hora Fim: {accessGroup.end_hour}</p>
						</Card>
					))}
			</div>
			<Pagination
				currentPage={currentPage}
				rowsPerPage={rowsPerPage}
				maxPage={maxPage}
				total={total}
				changePage={(page) =>
					setCurrentPage(page)
				}
				changeRowsPerPage={(rowsPerPage) =>
					setRowsPerPage(rowsPerPage)
				}
			/>
		</>
	);
};

export default ListAccessGroups;
